// extracted by mini-css-extract-plugin
export default {"answersList":"AnswersList_answersList__Xsc-k"};